module.exports = __webpack_public_path__ + "img/jiejue2.1789359e.png";